import QS from 'qs'
import { GET, DELETE, POSTJSON } from './https'

// 获取后台项目列表
export const getQuestionnaire = (params) =>
  GET(`/api/manager/questionnaire`, params)

// 获取验证码
export const getVerificationCode = (params) =>
  POSTJSON(`/api/manager/account/getVerificationCode?phoneNumber=${params}`)

// 登录
export const login = (params) =>
  POSTJSON(`/api/manager/account/login?${QS.stringify(params)}`)

// 投放
export const launch = (params) =>
  POSTJSON(`/api/manager/questionnaire/launch/${params}`)

// 暂停投放
export const stopLaunch = (params) =>
  POSTJSON(`/api/manager/questionnaire/stopLaunch/${params}`)

// 复制
export const copy = (params) =>
  POSTJSON(`/api/manager/questionnaire/copy/${params}`)

// 获取微信用户列表
export const getUser = (params) => GET('/api/manager/user', params)

// 获取用户的所有参与答题记录
export const getRecords = (params) =>
  GET(`/api/manager/user/${params.id}/records`, params.searchParams)

// 投放属性设置（红包金额/个数/截止时间...）
export const settingApi = (params) =>
  POSTJSON(
    `/api/manager/questionnaire/setting/${params.id}`,
    params.settingViewModel,
    { 'Content-Type': 'application/json-patch+json' }
  )

// 获取参与项目答题用户的记录
export const getLaunchDetail = (params) =>
  GET(
    `/api/manager/questionnaire/${params.id}/launchDetail`,
    params.searchParams
  )

// 获取管理员列表
export const getAdministration = (params) =>
  GET('/api/manager/administration', params)

// 添加管理员
export const addAdministration = (params) =>
  POSTJSON(`/api/manager/administration?${QS.stringify(params)}`)

export const deleteAdmin = (params) =>
  DELETE(`/api/manager/administration/${params}`)

// 获取管理员列表
export const getTransferRecords = (params) =>
  GET('/api/manager/transferRecords', params)

// 获取后台项目列表
export const getUsual = (params) =>
  GET(`/api/manager/questionnaire/usual`, params)

// 获取结算列表
export const getFinance = (params) => GET(`/api/manager/finance`, params)

// 生成结算
export const settlementPrice = () => GET(`/api/manager/finance/settlementPrice`)

// 汇总
export const getTransferList = (params) =>
  GET(`/api/manager/questionnaire/getTransferList`, params)
//更新充值状态
export const updateRechargeState = (params) =>
  GET(`/api/manager/finance/updateRechargeState/${params}`)

export const getLaunchDetails = (params) =>
  GET(`/api/manager/finance/getLaunchDetails`, params)

export const getShareDetails = (params) =>
  GET(`/api/manager/finance/getShareDetails`, params)

// 获取参与项目答题用户的记录
export const getTags = () =>
  GET(`/api/manager/tags`)

// 获取用户标签
export const getUserTags = (params) =>
  GET(`/api/manager/user/getUserTags?${QS.stringify(params)}`)
